import * as React from "react";

import { Trans } from "react-i18next";
import i18next from "i18next";

import {
  Button,
  Callout,
  Dialog,
  DialogBody,
  DialogFooter,
  FormGroup,
  NumericInput,
  Spinner,
} from "@blueprintjs/core";
import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../utils/AuthenticatedFetch";
import { DateInput3 } from "@blueprintjs/datetime2";
import IRVEFare from "./IRVEFare";

export default class IRVEFares extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fares: undefined,
      creation: false,
      edition: 0,
      price_Kwh: 0,
      price_session: 0,
      price_minutes: 0,
      from: new Date(),
    };
  }

  componentDidMount() {
    this.update();
  }

  razForm() {
    this.setState({
      creation: false,
      edition: 0,
      price_Kwh: 0,
      price_session: 0,
      price_minutes: 0,
      from: new Date(),
    });
  }

  update() {
    authenticatedGetFetch("/irve/fares", (res) =>
      this.setState({ fares: res })
    );
  }

  render() {
    return (
      <Callout icon="dollar" title={<Trans>fare management</Trans>}>
        <Callout intent="primary">
          <Trans>irve fare rules application rules</Trans>
        </Callout>
        <div>
          <Button
            icon="edit"
            text={<Trans>edit charging rate</Trans>}
            onClick={() => this.setState({ creation: true })}
          />
        </div>

        <br />
        {this.state.fares ? (
          this.state.fares.length === 0 ? (
            <Callout intent="danger">
              <Trans>no fare rules declared</Trans>
            </Callout>
          ) : (
            this.state.fares.map((fare, index) => (
              <span key={"cf" + fare.id}>
                <IRVEFare {...fare} to={this.state.fares[index - 1]?.from} />
                <br />
              </span>
            ))
          )
        ) : (
          <Spinner />
        )}
        {/* edit fare dialog */}
        <Dialog
          title={<Trans>edit charging rate</Trans>}
          icon="add"
          isOpen={this.state.creation}
          onClose={() => this.razForm()}
        >
          <DialogBody>
            <FormGroup
              label={<Trans>application date</Trans>}
              labelFor="applicationdate"
              inline={true}
            >
              <DateInput3
                id="applicationdate"
                minDate={new Date()}
                defaultValue={new Date() + 1}
                timePrecision="minute"
                formatDate={(date) => date.toLocaleString(i18next.language)}
                parseDate={(str) => new Date(str)}
                onChange={(selectedDate) =>
                  this.setState({ from: selectedDate })
                }
                showTimezoneSelect={false}
                locale={i18next.language}
                closeOnSelection={false}
              />
            </FormGroup>

            <FormGroup
              label={<Trans>session price</Trans>}
              helperText={<Trans>fixed price for all charges</Trans>}
              labelFor="sessionprice"
              inline={true}
            >
              <NumericInput
                leftIcon="euro"
                id="sessionprice"
                min={0}
                stepSize={0.1}
                minorStepSize={0.01}
                onValueChange={(val, vals) => {
                  if (!isNaN(vals))
                    this.setState({
                      price_session: Math.max(0, val.toFixed(2)),
                    });
                }}
              />
            </FormGroup>

            <FormGroup
              label={<Trans>Kwh price</Trans>}
              helperText={<Trans>price based on electricity consumption</Trans>}
              labelFor="kwhprice"
              inline={true}
            >
              <NumericInput
                leftIcon="euro"
                id="kwhprice"
                min={0}
                stepSize={0.1}
                minorStepSize={0.01}
                onValueChange={(val, vals) => {
                  if (!isNaN(vals))
                    this.setState({
                      price_Kwh: Math.max(0, val.toFixed(2)),
                    });
                }}
              />
            </FormGroup>

            <FormGroup
              label={<Trans>minute price</Trans>}
              labelFor="minuteprice"
              helperText={<Trans>price based on charge time</Trans>}
              inline={true}
            >
              <NumericInput
                leftIcon="euro"
                id="minuteprice"
                min={0}
                stepSize={0.1}
                minorStepSize={0.01}
                onValueChange={(val, vals) => {
                  if (!isNaN(vals))
                    this.setState({
                      price_minutes: Math.max(0, val.toFixed(2)),
                    });
                }}
              />
            </FormGroup>
          </DialogBody>
          <DialogFooter
            actions={
              <Button
                intent="primary"
                text={<Trans>send</Trans>}
                onClick={() =>
                  authenticatedPostFetch(
                    "/irve/fare",
                    {
                      from: this.state.from,
                      price_Kwh: this.state.price_Kwh,
                      price_session: this.state.price_session,
                      price_minutes: this.state.price_minutes,
                    },
                    () => {
                      this.update();
                      this.razForm();
                    }
                  )
                }
              />
            }
          />
        </Dialog>
      </Callout>
    );
  }
}
